import { create, StateCreator } from "zustand";
import { devtools, persist } from "zustand/middleware";

type AuthState = {
  currentUser: {
    fullName: string;
    email: string;
    area: string;
  };
  id: string;
  accessToken?: string | null;
  isAuthenticated: boolean;
  evaluation: boolean;
  loginUser: (response: any) => void;
  logout: () => void;
};

const storeApi: StateCreator<AuthState> = (set) => ({
  currentUser: {
    fullName: "",
    email: "",
    area: "",
  },
  id: "",
  accessToken: null,
  isAuthenticated: false,
  evaluation: false,

  // 🧩 When user logs in
  loginUser: (response: any) => {

    // ✅ Store data in Zustand and persist accessToken
    set({
      currentUser: {
        fullName: response.name,
        email: response.email,
        area: response.area,
      },
      id: response.id,
      accessToken: response.accessToken ?? null,
      isAuthenticated: true,
      evaluation: response.evaluation ?? false,
    });

    try {
      if (response.accessToken) {
        localStorage.setItem("accessToken", response.accessToken);
      }
    } catch (e) {
      console.warn("Could not persist accessToken to localStorage", e);
    }
  },

  // 🚪 When user logs out
  logout: () => {
    set({
      currentUser: { fullName: "", email: "", area: "" },
      id: "",
      accessToken: null,
      isAuthenticated: false,
      evaluation: false,
    });

    try {
      localStorage.removeItem("accessToken");
    } catch (e) {
      console.warn("Could not remove accessToken from localStorage", e);
    }
  },
});

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(storeApi, {
      name: "auth",
    })
  )
);

useAuthStore.subscribe((nextState) => {
  if (!nextState.isAuthenticated) {
    try {
      localStorage.removeItem("accessToken");
    } catch (e) {
      console.warn("Could not remove accessToken from localStorage", e);
    }
  }
});
